<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-2">

            <!-- Card stats -->
            <div class="row pt-md-4">
                <div class="col-md-12">
                    <h1>Decimal to Octal Converter</h1>
                </div>

                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.input"
                               placeholder="Enter Decimal Value"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                    <div class="form-group">
                        <input type="text" class="form-control input-group" v-model="values.output"
                               placeholder="Result Oct"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-lg-12">
                    <button class="btn btn-dark" @click="calc"><i class="ni ni-sound-wave"></i> Convert</button>
                    <button class="btn btn-primary" @click="clean"><i class="ni ni-button-power"></i> Clear
                    </button>
                    <button v-if="values.output" class="btn btn-info"
                            v-clipboard:copy="values.output"
                            v-clipboard:success="onCopy">
                        <i class="ni ni-ungroup"></i> Copy
                    </button>
                </div>
            </div>

        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--8 bg-dark pb-4">

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-12 mb-xl-12">
                    <div class="card">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="mb-0">Latest Results</h3>
                                </div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <base-table thead-classes="thead-light"
                                        :data="tableData">
                                <template slot="columns">
                                    <th>In</th>
                                    <th>Input Data</th>
                                    <th>Out</th>
                                    <th>Output Data</th>

                                </template>

                                <template slot-scope="{row}">
                                    <th scope="row">
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.input"
                                                v-clipboard:success="onCopy">
                                            {{row.inType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </th>
                                    <th scope="row">
                                        {{row.input}}
                                    </th>
                                    <td>
                                        <button class="btn btn-sm"
                                                v-clipboard:copy="row.output"
                                                v-clipboard:success="onCopy">
                                            {{row.outType}} <i class="ni ni-ungroup"></i>
                                        </button>
                                    </td>
                                    <td style="overflow-x:auto;">
                                        {{row.output}}
                                    </td>

                                </template>

                            </base-table>
                        </div>

                    </div>
                    <div v-if="!this.$root.mobile" class="card shadow mt-4 pl-2 pt-2 pb-2 pr-2 bg-gradient-neutral">
                        <h1>Decimal</h1>
                        <p>
                            The decimal numeral system (also called base-ten positional numeral system, and occasionally
                            called denary) is the standard system for denoting integer and non-integer numbers. It is
                            the extension to non-integer numbers of the Hindu–Arabic numeral system.The way of denoting
                            numbers in the decimal system is often referred to as decimal notation.
                        </p>
                        <p>
                            A decimal numeral, or just decimal, or casually decimal number, refers generally to the
                            notation of a number in the decimal numeral system. Decimals may sometimes be identified for
                            containing a decimal separator (for example the "." in 10.00 or 3.14159). "Decimal" may also
                            refer specifically to the digits after the decimal separator, such as in "3.14 is the
                            approximation of ? to two decimals".</p>
                        <p>
                            The numbers that may be represented in the decimal system are the decimal fractions, that is
                            the fractions of the form a/10n, where a is an integer, and n is a non-negative integer.
                            The decimal system has been extended to infinite decimals, for representing any real number,
                            by using an infinite sequence of digits after the decimal separator (see Decimal
                            representation). In this context, the decimal numerals with a finite number of non–zero
                            places after the decimal separator are sometimes called terminating decimals. A repeating
                            decimal is an infinite decimal that after some place repeats indefinitely the same sequence
                            of digits (for example 5.123144144144144... = 5.123144). An infinite decimal represents a
                            rational number if and only if it is a repeating decimal or has a finite number of nonzero
                            digits.
                        </p>
                        <h1>Octal</h1>
                        <p>
                            The octal numeral system, or oct for short, is the base-8 number system, and uses the digits
                            0 to 7. Octal numerals can be made from binary numerals by grouping consecutive binary
                            digits into groups of three (starting from the right). For example, the binary
                            representation for decimal 74 is 1001010. Two zeroes can be added at the left: (00)1 001
                            010, corresponding the octal digits 1 1 2, yielding the octal representation 112.
                        </p>
                    </div>
                </div>
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'

    Vue.use(VueClipboard);

    export default {
        name: "DecToOct",
        directives: {
            'b-tooltip': BTooltipDirective
        },
        data() {
            return {
                values: {
                    input: null,
                    output: null
                },
                tableData: [],
            };
        },
        methods: {
            onCopy() {
                this.$notify({
                    type: 'success',
                    title: 'Copied to clipboard'
                })
            },
            revert: function () {

            },
            clean: function () {
                this.values.output = null;
                this.values.input = null;
                this.tableData = [];
            },
            calc: function () {
                if (this.values.input) {
                    this.values.output = (this.values.input * 1).toString(8);
                    this.tableData.unshift({
                        input: this.values.input,
                        inType: "dec",
                        output: this.values.output,
                        outType: "oct",
                    });

                    if (this.tableData.length > 8) {
                        this.tableData.splice(8, 1);
                    }
                }
            }
        },
        mounted() {

        }
    };
</script>
<style></style>
